import { ApexAutomationSearch } from './ApexAutomationSearch';
import { PeriscopeApexClass } from '.';
import { PeriscopeList } from '..';
import { SearchFilterQueryParams } from '../filters';
import { PeriscopeSfApexClass, SonarObjectType } from '@sonar-software/sonar-ts-types';
import React, { useCallback } from 'react';
import { usePeriscopeActions, useQueryResource } from '@hooks';

type ApexAutomation = PeriscopeSfApexClass & {
	sonarObjectType: SonarObjectType;
};

export interface ApexAutomationListProps {
	parentIndex: number;
	uri: string;
}

type Resource = ApexAutomation[];
export type ApexAutomationListQueryParams = SearchFilterQueryParams;

export const ApexAutomationList: React.FC<ApexAutomationListProps> = ({ parentIndex, uri }) => {
	const { openPeriscope } = usePeriscopeActions();
	const { loading, resource, updateParams } = useQueryResource<Resource, ApexAutomationListQueryParams>({ uri });

	const renderList = useCallback(
		(items: ApexAutomation[]) =>
			items?.map((item) => {
				const { displayName, sonarObjectId, sonarObjectType } = item;

				const handleClick = () => {
					openPeriscope({
						id: sonarObjectId,
						name: displayName,
						openedFromIndex: parentIndex,
						type: sonarObjectType
					});
				};

				return (
					<PeriscopeApexClass
						apex={ item }
						key={ sonarObjectId }
						onApexClick={ handleClick }
						sonarObjectType={ sonarObjectType } />
				);
			}),
		[ openPeriscope, parentIndex ]
	);

	return (
		<>
			<ApexAutomationSearch onChange={ updateParams } />
			<PeriscopeList
				list={ renderList }
				loading={ loading }
				results={ resource ?? [] } />
		</>
	);
};
